import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import AwardForm from './AwardsForm'
import React, { useEffect, useState } from 'react'

import { Form } from 'antd'
import { setResumeData } from '../../../../../OnBoarding/actions'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from '../DrawerStyle'
import {
  ButtonLocal,
  Text,
} from '../ProjectDetails/style'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getStudentDataById } from '../../../../actions'

const AwardsDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  studentId,
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [award, setAward] = useState([])
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)

  useEffect(() => {
    let internshipList = []
    studentFormData?.resume?.awards?.map((data, index) => {
      let formName = 'award_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          title: data?.title,
          organization: data?.organization,
          awarded_on: data?.awarded_on,
          description: formattedDescription,
          certificate: data?.certificate,
        },
      })
      return internshipList.push({
        component: AwardForm,
        formName: formName,
      })
    })
    setAward(internshipList)
  }, [studentFormData])

  const awardHandler = (isAdd, isDelete, deleteForm) => {
    let arr = []
    let formName = 'award_' + `${award?.length ? award?.length : 0}`

    arr.push({ component: AwardForm, formName: formName })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      setAward(cou => cou.concat(arr))
    }
    if (isDelete) {
      setIsUpdateButtonEnabled(false)
      let updatedList = award?.filter(data => data?.formName !== deleteForm)
      return setAward(updatedList)
    }
  }

  const submitHandler = async values => {
    let award = []

    Object.entries(values).forEach(([name, obj]) => {
      if (name.includes('award')) {
        award.push(obj)
      }
    })

    let payload = {
      isDirectTPOUpdate: false,
      admin: {
        ...studentFormData?.admin,
        countryCode: studentFormData?.admin?.countryCode,
      },
      student: studentFormData?.student ? {
        ...studentFormData?.student,
        id: studentId,
        instituteCampusId: studentFormData?.student?.instituteCampusId || studentFormData?.admin?.institute_campus_id,
      } : {
        id: studentId,
        instituteCampusId: studentFormData?.admin?.institute_campus_id,
      },
      degreeStreamMap: !studentFormData?.student?.isExpCandidate
        ? {
            degreeId: studentFormData?.currentCourse?.degreeId,
            streamId: studentFormData?.currentCourse?.streamId,
          }
        : {},
      studentPersonalProfile: studentFormData?.studentPersonalProfile,
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? {
            ...studentFormData?.currentCourse,
            marks: studentFormData?.currentCourse?.marks ?? 0,
          }
        : {},
      education: studentFormData?.education,
      resume: {
        ...studentFormData?.resume,
        awards: award,
      },
    }
    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.studentPersonalProfile?.secondaryEmail === null) {
      delete payload?.studentPersonalProfile?.secondaryEmail
    }
    if (payload?.studentPersonalProfile?.secondaryEmail === '') {
      delete payload?.studentPersonalProfile?.secondaryEmail
    }
    if (payload?.studentPersonalProfile?.registraionNo) {
      delete payload?.studentPersonalProfile?.registraionNo
    }
    studentFormData?.education?.map((item, index) => {
      if (item?.skills === null) delete payload?.education[index]?.skills
      if (item?.degreeStreamMapId === null)
        delete payload?.education[index]?.degreeStreamMapId
    })
    payload?.resume?.awards?.map((item, index) => {
      if (
        item?.certificate == null ||
        Object.keys(item?.certificate)?.length === 0
      ) {
        delete payload?.resume?.awards[index]?.certificate
      }
    })
    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }

    let response = await updateStudentData(payload)
    await dispatch(setResumeData(payload))
    
    dispatch(getStudentDataById(studentId)).catch(err => console.error('getStudentData error:', err))
    getPendingData().catch(err => console.error('getPendingData error:', err))
    
    if (response?.success === true) {
      SuccessMessage('Awards saved successfully!')
      setdrawerStatus(false)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }
  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler}
          id={'awardForm'}
          form={form}
          layout="vertical"
        >
          {!!award.length &&
            award.map((obj, index) => {
              return (
                <obj.component
                  key={index + 'award'}
                  form={form}
                  onRemove={awardHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                />
              )
            })}
        </Form>
        <ButtonLocal onClick={() => awardHandler(true, false)}>
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add Awards</Text>
          </Control>
        </ButtonLocal>
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'awardForm'}
          htmlType="submit"
          text={'Update'}
          disabled={isUpdateButtonEnabled}
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      width="675px"
      title={'Awards'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  )
}

export default AwardsDrawer
